import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-wrap" }
const _hoisted_2 = { class: "w-full px-4" }
const _hoisted_3 = { class: "relative flex flex-col align-middle w-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: _normalizeClass([_ctx.classes, "font-bold text-sm shadow hover:shadow-lg ease-linear transition-all duration-150 px-6 py-2 rounded outline-none focus:outline-none mr-1 mb-1 capitalize w-full"]),
          type: "button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleDropdown()))
        }, _toDisplayString(_ctx.title), 3),
        _createElementVNode("div", {
          class: _normalizeClass([{'hidden': !_ctx.dropdownPopoverShow, 'block': _ctx.dropdownPopoverShow}, "bg-white text-base z-50 py-2 list-none text-left rounded shadow-lg mt-1"]),
          style: {"min-width":"12rem"}
        }, [
          _renderSlot(_ctx.$slots, "default")
        ], 2)
      ])
    ])
  ]))
}